<!--
 * @Author: your name
 * @Date: 2022-04-02 18:09:16
 * @LastEditTime: 2022-04-02 18:18:24
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\components\Video.vue
-->
<template>
  <div>
    <!-- <video
      :id="id || 'videoElement'"
      class="centeredVideo"
      controls
      autoplay
      width="1024"
      height="576"
    ></video> -->
    <video src="/images/aaa.mp4" controls="controls" autoplay muted>
    your browser does not support the video tag
    </video>
  </div>
</template>

<script>
//import flvjs from "flv.js";
export default {
  name: "VideoShow",
  props: {
    id: String,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
    //   if (flvjs.isSupported()) {
    //     var videoElement = document.getElementById(this.id||'videoElement');
    //     var flvPlayer = flvjs.createPlayer({
    //       type: "flv",
    //       url: "http://39.106.70.134:8100/flv?port=1935&app=live",
    //     });
    //     flvPlayer.attachMediaElement(videoElement);
    //     flvPlayer.load();
    //     flvPlayer.play();
    //   }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>